// extracted by mini-css-extract-plugin
export default {"list":"ed2e6895e4a2"};